export enum SentimentCheckSetting {
    onlyHappy = 'only-happy',
    neutralReview = 'neutral-review',
    twoForReview = 'two',
    threeForReview = 'three',
    fourForReview = 'four',
    fiveForReview = 'five',
}